import type { ReactNode } from 'react';
import { Toaster } from './toaster';

interface ToastProviderProps {
  children: ReactNode;
}

export function ToastProvider({ children }: ToastProviderProps) {
  return (
    <>
      {children}
      <Toaster />
    </>
  );
}

export { useToast, toast } from './use-toast';
export type { ToastTone } from './use-toast';
